import { getItemLocalStorage } from '@cigam/template/dist/utils';
import { salvarControleAcesso } from 'src/Areas/Genericos/GE/services/controleAcessoMenuService';
import { ControleAcessoMenuDTO } from 'src/Areas/Genericos/GE/types/dtos/genericos';

const settingsStorage = getItemLocalStorage('settings');

const DEFAULT_BATCH_SIZE = 50;

const parsedBatchSize = Number(settingsStorage?.menuMaxAcessos);

const BATCH_SIZE =
  Number.isFinite(parsedBatchSize) && parsedBatchSize > 0
    ? parsedBatchSize
    : DEFAULT_BATCH_SIZE;

let buffer: ControleAcessoMenuDTO[] = [];
let rotaAnterior: string | null = null;
let isFlushing = false;

function getNow() {
  const now = new Date();
  return {
    data: now.toLocaleDateString('pt-BR'),
    hora: now.toLocaleTimeString('pt-BR'),
  };
}

async function enviarLote(acessos: ControleAcessoMenuDTO[]) {
  try {
    await salvarControleAcesso(acessos);
  } catch (err) {
    console.error('[RouteTracker] Falha ao enviar lote:', err);

    // Recoloca no buffer caso falhe
    buffer = [...acessos, ...buffer];
  }
}

// Função responsável por enviar os acessos pendentes
export async function flushRouteTracker(): Promise<void> {
  if (isFlushing) return;
  if (buffer.length === 0) return;

  isFlushing = true;

  const lote = [...buffer];
  buffer = [];

  try {
    await enviarLote(lote);
  } finally {
    isFlushing = false;
  }
}

// Função principal chamada a cada mudança de rota
export async function trackRoute(
  pathname: string,
  usuario?: string
): Promise<void> {
  if (!pathname) return;

  if (pathname === rotaAnterior) return;

  // Ignora rotas raiz ou inválidas para evitar gravações com "/" e portal vazio
  if (pathname === '/' || pathname.trim() === '') return;

  const { data, hora } = getNow();

  const pathParts = pathname.split('/');

  const portalAtivo = pathParts.length > 1 ? pathParts[1] : '';

  const acesso: ControleAcessoMenuDTO = {
    Usuario: usuario || 'anonimo',
    Portal: portalAtivo,
    UrlAcessada: pathname,
    DataAcesso: data,
    HoraAcesso: hora,
    Modulo: '',
  };

  buffer.push(acesso);
  rotaAnterior = pathname;

  if (buffer.length >= BATCH_SIZE) {
    await flushRouteTracker();
  }
}
